import { Component } from '@angular/core';

@Component({
  selector: 'app-ambassadors',
  templateUrl: './ambassadors.component.html'
})
export class AmbassadorsComponent { }
